import React, { useState, useContext, useEffect } from 'react';
import api from '../utils/api';
import './styles/PaymentReportMonthlyPage.css';
import AuthContext from '../context/AuthContext';
import moment from 'moment';

const AttendanceMonthlyReportPage = () => {
    const { user } = useContext(AuthContext);
    const [attendanceData, setAttendanceData] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [dateMonth, setDateMonth] = useState('');
    const [teacher, setTeacher] = useState({});
    const [dateArray, setDateArray] = useState([]);
    const [errorMessage, setErrorMessage] = useState(''); // State untuk menyimpan pesan kesalahan

    useEffect(() => {
        api.post('/teacher/getTeacher', {
            data: {
                username: user.username
            }
        })
        .then(response => {
            const teacherData = response.data.data;
            setTeacher(teacherData);
        })
        .catch(error => console.error('Error fetching teacher list:', error));
    }, [user.username]);

    const createDateArray = (startDate, endDate) => {
        const dates = [];
        let currentDate = moment(startDate);
        while (currentDate.isSameOrBefore(endDate)) {
            dates.push(currentDate.format('YYYY-MM-DD'));
            currentDate.add(1, 'days');
        }
        return dates;
    };

    const handleSearch = async () => {
        const [year, month] = dateMonth.split('-');
        if (!teacher.teacher_name || !year || !month) {
            alert('Silakan isi nama guru, bulan, dan tahun!');
            return;
        }
        
        const startDate = moment(`${year}-${month}-01`).startOf('month');
        const endDate = startDate.clone().endOf('month');
        const generatedDateArray = createDateArray(startDate, endDate);

        try {
            const response = await api.post('/teacher/attendance/monthlyReport', {
                data: {
                    teacherData: {
                        teacher_name: searchName ? searchName : teacher.teacher_name,
                        dateMonth: dateMonth
                    }   
                }
            });

            // Periksa apakah data attendance ada
            if (!response.data.data || response.data.data.length === 0) {
                setErrorMessage('Data kehadiran tidak ditemukan untuk guru ini.');
                setAttendanceData([]); // Reset data attendance
            } else {
                setAttendanceData(response.data.data);
                setDateArray(generatedDateArray);
                setErrorMessage(''); // Reset pesan kesalahan jika data ditemukan
            }
        } catch (error) {
            console.error('Error fetching attendance data:', error);
            setErrorMessage('Terjadi kesalahan saat mengambil data kehadiran.');
        }
    };

    return (
        <div className="inventory-page">
            <div className="page-title">Monthly Attendance Report</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td>
                                    {teacher.User?.Role?.name === 'teacher' ? 
                                    <td>
                                        <input 
                                            type="text" 
                                            value={teacher.teacher_name || ''} 
                                            readOnly={true}
                                        />
                                    </td>
                                    :
                                    <td>
                                        <input 
                                            type="text" 
                                            value={searchName} 
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Date Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="dateMonth"
                                            value={dateMonth} 
                                            onChange={e => setDateMonth(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} {/* Tampilkan pesan kesalahan */}
                    </div>
                </div>
                <div className="section">
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th><center>Date</center></th>
                                    <th><center>Arrival Time</center></th>
                                    <th><center>Departure Time</center></th>
                                </tr>
                            </thead>
                            <tbody>
                                {dateArray.map(date => {
                                    const arrival = attendanceData.TeacherArrivals?.find(arrival => arrival.arrival_date === date);
                                    const departure = attendanceData.TeacherDepartures?.find(departure => departure.departure_date === date);
                                    const leave = attendanceData.TeacherLeaves?.find(leave => leave.leave_date === date);
                                    return (
                                        <tr key={date} className={leave ? 'highlight' : ''}>
                                            <td><center>{moment(date).format('DD MMMM YYYY')}</center></td>
                                            {leave ? <td><center>On Leave</center></td> : <td><center>{arrival ? arrival.arrival_time : ''}</center></td> }
                                            {leave ? <td><center>On Leave</center></td> : <td><center>{departure ? departure.departure_time : ''}</center></td> }
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttendanceMonthlyReportPage;
